import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useDeferredMedia } from '../hooks/useDeferredMedia';
import { getScreenshotPreview, getScreenshotPreviewSet } from '../lib/screenshotPreview';

export const IOS_SNAPSHOT_BASE = 'snapshots/20261004T181317Z';

interface MarketingScreenshotProps {
  base: string;
  alt: string;
  caption: string;
  className?: string;
}

const MarketingScreenshot: React.FC<MarketingScreenshotProps> = ({ base, alt, caption, className }) => {
  const { theme, colors } = useTheme();
  const { ref, shouldLoad } = useDeferredMedia<HTMLElement>();
  const deviceBorder = theme === 'light' ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.2)';
  return (
    <figure ref={ref} className={`w-72 sm:w-80 max-w-full mx-auto ${className ?? ''}`.trim()}>
      <div className="rounded-[1.6rem] border-4 overflow-hidden shadow-2xl" style={{ borderColor: deviceBorder }}>
        <img
          src={shouldLoad ? getScreenshotPreview(`/assets/screenshots/ios-delivery/${base} - ${theme === 'dark' ? 'Dark' : 'Light'}.png`) : undefined}
          srcSet={shouldLoad ? getScreenshotPreviewSet(`/assets/screenshots/ios-delivery/${base} - ${theme === 'dark' ? 'Dark' : 'Light'}.png`) : undefined}
          sizes="(min-width: 640px) 320px, 288px"
          alt={alt}
          className="w-full h-auto"
          width={1320}
          height={2868}
          loading="lazy"
        />
      </div>
      <figcaption className="text-xs mt-3 text-center" style={{ color: colors.textSecondary }}>
        {caption}
      </figcaption>
    </figure>
  );
};

export default MarketingScreenshot;
